<template>
  <v-row dense>
    <v-col>
      <v-container fluid>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <v-row dense align="center">
                <v-col cols="auto" class="text-subtitle-2">
                  {{ medicalRequest.medicalRequestItem.name }}
                </v-col>

                <v-col cols="auto">
                  <WorkflowableStatus :workflowable="medicalRequest" />
                </v-col>

                <v-col
                  class="text-body-2"
                  cols="auto"
                  v-if="
                    medicalRequest.futureService && !medicalRequest.executedAt
                  "
                >
                  <v-chip small outlined color="light-blue">
                    Executar em:
                    {{ formatMedicalRequestDate(medicalRequest.plannedDate) }}
                  </v-chip>
                </v-col>

                <v-col class="text-body-2" cols="auto">
                  <span class="font-weight-bold">
                    Solicitado em:
                  </span>
                  {{ formatMedicalRequestDateTime(medicalRequest.createdAt) }}
                </v-col>

                <v-col class="text-body-2">
                  <span class="font-weight-bold">
                    Executado em:
                  </span>
                  <span v-if="medicalRequest.executedAt">
                    {{
                      formatMedicalRequestDateTime(medicalRequest.executedAt)
                    }}
                  </span>
                  <span v-else>
                    Não realizado
                  </span>
                </v-col>

                <v-col cols="auto">
                  <MedicalRequestWorkflowMoviment
                    :attendance="attendance"
                    :medicalRequest="medicalRequest"
                    :refreshQueue="refreshQueue"
                    :refreshMedicalRequest="refreshMedicalRequest"
                    :disabled="disabled"
                    :showExecuteBtn="showExecuteBtn"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-header>

            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="3">
                  <v-row dense>
                    <v-col class="text-body-2 font-weight-bold">
                      Solicitante
                    </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col>
                      {{ medicalRequest.requester.employee.name }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="3" v-if="medicalRequest.forwardTo">
                  <v-row dense>
                    <v-col class="text-body-2 font-weight-bold">
                      Encaminhar para Executante
                    </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col>
                      {{ medicalRequest.forwardTo.employee.name }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="3">
                  <v-row dense>
                    <v-col class="text-body-2 font-weight-bold">
                      Hipótese diagnóstica
                    </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col>
                      {{ medicalRequest.cid.codeDescription }}
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="3" v-if="medicalRequest.site">
                  <v-row dense>
                    <v-col class="text-body-2 font-weight-bold"> Local </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col>
                      {{ medicalRequest.site }}
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row dense v-if="medicalRequest.observation">
                <v-col cols="6">
                  <v-row dense>
                    <v-col class="text-body-2 font-weight-bold">
                      Observações
                    </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col>
                      {{ medicalRequest.observation }}
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="3">
                  <v-row dense>
                    <v-col class="text-body-2 font-weight-bold">
                      Numero da Solicitação
                    </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col>
                      {{ medicalRequest.requestNumber }}
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="3">
                  <v-row dense>
                    <v-col class="text-body-2 font-weight-bold">
                      Executado em
                    </v-col>
                  </v-row>

                  <v-row dense>
                    <v-col v-if="medicalRequest.executedAt">
                      <v-icon class="mb-1" color="green">
                        eva-checkmark-circle-2
                      </v-icon>
                      {{
                        formatMedicalRequestDateTime(medicalRequest.executedAt)
                      }}
                    </v-col>
                    <v-col v-else>
                      <v-icon class="mb-1" color="red">
                        eva-close-circle
                      </v-icon>
                      <span> Não realizada </span>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
import WorkflowableStatus from "@/components/workflowable/status.vue";
import MedicalRequestWorkflowMoviment from "@/components/medical_request/list/item/workflow_moviment.vue";

export default {
  name: "MedicalRequestListItem",
  props: {
    medicalRequest: Object,
    attendance: Object,
    showExecuteBtn: {
      type: Boolean,
      default: true,
    },
    refreshQueue: {
      type: Function,
      default: () => {},
    },
    refreshMedicalRequest: {
      type: Function,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    WorkflowableStatus,
    MedicalRequestWorkflowMoviment,
  },
  methods: {
    formatMedicalRequestDate(date) {
      if (!date) return "";

      return this.$moment(date).format("MM/YYYY");
    },
    formatMedicalRequestDateTime(date) {
      if (!date) return "";

      return this.$moment(date).format("DD/MM/YYYY à\\s HH:mm");
    },
  },
};
</script>

<style lang="scss" scoped></style>
